// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../node_modules/css-loader/dist/cjs.js!../node_modules/ol/ol.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html,
body {
  margin: 0;
}
.root .ant-app {
  display: contents;
}
.root .suspense-spin {
  margin: auto;
}
.root .suspense-spin .suspense-spin-icon {
  font-size: 48px;
}
.ant-modal-mask,
.ant-drawer-mask {
  backdrop-filter: blur(2px) grayscale(100%);
}
`, "",{"version":3,"sources":["webpack://./src/index.less"],"names":[],"mappings":"AAEA;;EAEE,SAAA;AAAF;AAGA;EAGI,iBAAA;AAHJ;AAAA;EAOI,YAAA;AAJJ;AAHA;EAUM,eAAA;AAJN;AASA;;EAEE,0CAAA;AAPF","sourcesContent":["@import '~ol/ol.css';\n\nhtml,\nbody {\n  margin: 0;\n}\n\n.root {\n\n  .ant-app {\n    display: contents;\n  }\n\n  .suspense-spin {\n    margin: auto;\n\n    .suspense-spin-icon {\n      font-size: 48px;\n    }\n  }\n}\n\n.ant-modal-mask,\n.ant-drawer-mask {\n  backdrop-filter: blur(2px) grayscale(100%);\n}\n\n@drawer-width: 600px;@primary-color: #137CBD;@info-color: #137CBD;@success-color: #0F9960;@warning-color: #D9822B;@error-color: #DB3737;@link-color: #137CBD;@font-size-base: 14px;@heading-color: rgba(0, 0, 0, 0.85);@text-color: rgba(0, 0, 0, 0.65);@text-color-secondary: rgba(0, 0, 0, .45);@disabled-color: rgba(0, 0, 0, .25);@border-radius-base: 0px;@border-color-base: #d9d9d9;@box-shadow-base: 0 2px 8px rgba(0, 0, 0, 0.15);"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
